var _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgConnexionImageMiddle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1459.542,
    height: 599.934,
    viewBox: "0 0 1459.542 599.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9517",
    "data-name": "Groupe 9517",
    transform: "translate(-4.589 -17.767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9479",
    "data-name": "Groupe 9479",
    transform: "translate(0 0)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9352",
    "data-name": "Groupe 9352",
    transform: "translate(1376.269 175.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9351",
    "data-name": "Groupe 9351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9350",
    "data-name": "Groupe 9350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16191",
    "data-name": "Trac\\xE9 16191",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9355",
    "data-name": "Groupe 9355",
    transform: "translate(627.519 142.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9354",
    "data-name": "Groupe 9354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9353",
    "data-name": "Groupe 9353"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16192",
    "data-name": "Trac\\xE9 16192",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9358",
    "data-name": "Groupe 9358",
    transform: "translate(754.309 74.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9357",
    "data-name": "Groupe 9357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9356",
    "data-name": "Groupe 9356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16193",
    "data-name": "Trac\\xE9 16193",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9361",
    "data-name": "Groupe 9361",
    transform: "translate(732.899 190.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9360",
    "data-name": "Groupe 9360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9359",
    "data-name": "Groupe 9359"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16194",
    "data-name": "Trac\\xE9 16194",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9364",
    "data-name": "Groupe 9364",
    transform: "translate(643.998 224.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9363",
    "data-name": "Groupe 9363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9362",
    "data-name": "Groupe 9362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16195",
    "data-name": "Trac\\xE9 16195",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9367",
    "data-name": "Groupe 9367",
    transform: "translate(549.831 292.127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9366",
    "data-name": "Groupe 9366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9365",
    "data-name": "Groupe 9365"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16196",
    "data-name": "Trac\\xE9 16196",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9370",
    "data-name": "Groupe 9370",
    transform: "translate(405.605 186.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9369",
    "data-name": "Groupe 9369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9368",
    "data-name": "Groupe 9368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16197",
    "data-name": "Trac\\xE9 16197",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9373",
    "data-name": "Groupe 9373",
    transform: "translate(244.46 243.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9372",
    "data-name": "Groupe 9372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9371",
    "data-name": "Groupe 9371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16198",
    "data-name": "Trac\\xE9 16198",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9376",
    "data-name": "Groupe 9376",
    transform: "translate(36.755 134.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9375",
    "data-name": "Groupe 9375",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9374",
    "data-name": "Groupe 9374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16199",
    "data-name": "Trac\\xE9 16199",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9379",
    "data-name": "Groupe 9379",
    transform: "translate(153.106 399.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9378",
    "data-name": "Groupe 9378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9377",
    "data-name": "Groupe 9377"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16200",
    "data-name": "Trac\\xE9 16200",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9382",
    "data-name": "Groupe 9382",
    transform: "translate(345.835 369.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9381",
    "data-name": "Groupe 9381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9380",
    "data-name": "Groupe 9380"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16201",
    "data-name": "Trac\\xE9 16201",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9385",
    "data-name": "Groupe 9385",
    transform: "translate(469.519 401.594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9384",
    "data-name": "Groupe 9384",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9383",
    "data-name": "Groupe 9383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16202",
    "data-name": "Trac\\xE9 16202",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9388",
    "data-name": "Groupe 9388",
    transform: "translate(753.621 280.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9387",
    "data-name": "Groupe 9387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9386",
    "data-name": "Groupe 9386"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16203",
    "data-name": "Trac\\xE9 16203",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9391",
    "data-name": "Groupe 9391",
    transform: "translate(959.444 302.572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9390",
    "data-name": "Groupe 9390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9389",
    "data-name": "Groupe 9389"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16204",
    "data-name": "Trac\\xE9 16204",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9394",
    "data-name": "Groupe 9394",
    transform: "translate(1353.837 443.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9393",
    "data-name": "Groupe 9393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9392",
    "data-name": "Groupe 9392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16205",
    "data-name": "Trac\\xE9 16205",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9397",
    "data-name": "Groupe 9397",
    transform: "translate(1446.732 289.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9396",
    "data-name": "Groupe 9396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9395",
    "data-name": "Groupe 9395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16206",
    "data-name": "Trac\\xE9 16206",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9400",
    "data-name": "Groupe 9400",
    transform: "translate(1272.518 344.724)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9399",
    "data-name": "Groupe 9399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9398",
    "data-name": "Groupe 9398"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16207",
    "data-name": "Trac\\xE9 16207",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9403",
    "data-name": "Groupe 9403",
    transform: "translate(1141.728 386.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9402",
    "data-name": "Groupe 9402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9401",
    "data-name": "Groupe 9401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16208",
    "data-name": "Trac\\xE9 16208",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9406",
    "data-name": "Groupe 9406",
    transform: "translate(1057.283 284.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9405",
    "data-name": "Groupe 9405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9404",
    "data-name": "Groupe 9404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16209",
    "data-name": "Trac\\xE9 16209",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9409",
    "data-name": "Groupe 9409",
    transform: "translate(1150.111 244.846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9408",
    "data-name": "Groupe 9408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9407",
    "data-name": "Groupe 9407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16210",
    "data-name": "Trac\\xE9 16210",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9412",
    "data-name": "Groupe 9412",
    transform: "translate(1224.88 132.673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9411",
    "data-name": "Groupe 9411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9410",
    "data-name": "Groupe 9410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16211",
    "data-name": "Trac\\xE9 16211",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9415",
    "data-name": "Groupe 9415",
    transform: "translate(1447.124 43.854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9414",
    "data-name": "Groupe 9414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9413",
    "data-name": "Groupe 9413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16212",
    "data-name": "Trac\\xE9 16212",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9418",
    "data-name": "Groupe 9418",
    transform: "translate(1402.793 17.677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9417",
    "data-name": "Groupe 9417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9416",
    "data-name": "Groupe 9416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16213",
    "data-name": "Trac\\xE9 16213",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9421",
    "data-name": "Groupe 9421",
    transform: "translate(1449.56 422.786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9420",
    "data-name": "Groupe 9420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9419",
    "data-name": "Groupe 9419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16214",
    "data-name": "Trac\\xE9 16214",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9424",
    "data-name": "Groupe 9424",
    transform: "translate(606.624 376.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9423",
    "data-name": "Groupe 9423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9422",
    "data-name": "Groupe 9422"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16215",
    "data-name": "Trac\\xE9 16215",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9427",
    "data-name": "Groupe 9427",
    transform: "translate(206.088 500.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9426",
    "data-name": "Groupe 9426",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9425",
    "data-name": "Groupe 9425"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16216",
    "data-name": "Trac\\xE9 16216",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9430",
    "data-name": "Groupe 9430",
    transform: "translate(4.5 356.785)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9429",
    "data-name": "Groupe 9429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9428",
    "data-name": "Groupe 9428"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16217",
    "data-name": "Trac\\xE9 16217",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9433",
    "data-name": "Groupe 9433",
    transform: "translate(913.139 402.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9432",
    "data-name": "Groupe 9432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9431",
    "data-name": "Groupe 9431"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16218",
    "data-name": "Trac\\xE9 16218",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9436",
    "data-name": "Groupe 9436",
    transform: "translate(1277.726 503.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9435",
    "data-name": "Groupe 9435",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9434",
    "data-name": "Groupe 9434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16219",
    "data-name": "Trac\\xE9 16219",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9439",
    "data-name": "Groupe 9439",
    transform: "translate(1444.069 561.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9438",
    "data-name": "Groupe 9438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9437",
    "data-name": "Groupe 9437"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16220",
    "data-name": "Trac\\xE9 16220",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9442",
    "data-name": "Groupe 9442",
    transform: "translate(849.081 224.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9441",
    "data-name": "Groupe 9441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9440",
    "data-name": "Groupe 9440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16221",
    "data-name": "Trac\\xE9 16221",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9445",
    "data-name": "Groupe 9445",
    transform: "translate(974.583 204.37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9444",
    "data-name": "Groupe 9444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9443",
    "data-name": "Groupe 9443"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16222",
    "data-name": "Trac\\xE9 16222",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9448",
    "data-name": "Groupe 9448",
    transform: "translate(957.191 123.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9447",
    "data-name": "Groupe 9447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9446",
    "data-name": "Groupe 9446"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16223",
    "data-name": "Trac\\xE9 16223",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9451",
    "data-name": "Groupe 9451",
    transform: "translate(491.926 159.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9450",
    "data-name": "Groupe 9450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9449",
    "data-name": "Groupe 9449"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16224",
    "data-name": "Trac\\xE9 16224",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9454",
    "data-name": "Groupe 9454",
    transform: "translate(503.526 208.747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9453",
    "data-name": "Groupe 9453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9452",
    "data-name": "Groupe 9452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16225",
    "data-name": "Trac\\xE9 16225",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9457",
    "data-name": "Groupe 9457",
    transform: "translate(1335.534 603.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9456",
    "data-name": "Groupe 9456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9455",
    "data-name": "Groupe 9455"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16226",
    "data-name": "Trac\\xE9 16226",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9460",
    "data-name": "Groupe 9460",
    transform: "translate(1076.817 475.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9459",
    "data-name": "Groupe 9459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9458",
    "data-name": "Groupe 9458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16227",
    "data-name": "Trac\\xE9 16227",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9463",
    "data-name": "Groupe 9463",
    transform: "translate(1241.143 67.898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9462",
    "data-name": "Groupe 9462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9461",
    "data-name": "Groupe 9461"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16228",
    "data-name": "Trac\\xE9 16228",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9466",
    "data-name": "Groupe 9466",
    transform: "translate(300.941 145.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9465",
    "data-name": "Groupe 9465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9464",
    "data-name": "Groupe 9464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16229",
    "data-name": "Trac\\xE9 16229",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9469",
    "data-name": "Groupe 9469",
    transform: "translate(73.593 47.255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9468",
    "data-name": "Groupe 9468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9467",
    "data-name": "Groupe 9467"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16230",
    "data-name": "Trac\\xE9 16230",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9472",
    "data-name": "Groupe 9472",
    transform: "translate(174.772 111.862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9471",
    "data-name": "Groupe 9471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9470",
    "data-name": "Groupe 9470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16231",
    "data-name": "Trac\\xE9 16231",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9475",
    "data-name": "Groupe 9475",
    transform: "translate(64.822 568.762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9474",
    "data-name": "Groupe 9474",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9473",
    "data-name": "Groupe 9473"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16232",
    "data-name": "Trac\\xE9 16232",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9478",
    "data-name": "Groupe 9478",
    transform: "translate(722.167 322.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9477",
    "data-name": "Groupe 9477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9476",
    "data-name": "Groupe 9476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16233",
    "data-name": "Trac\\xE9 16233",
    d: "M7.24.091a7.386,7.386,0,0,1,7.33,7.176,6.95,6.95,0,0,1-7.151,6.994A7.386,7.386,0,0,1,.089,7.085,6.95,6.95,0,0,1,7.24.091Z",
    fill: "#002b53"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9516",
    "data-name": "Groupe 9516",
    transform: "translate(6 6.39)",
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9514",
    "data-name": "Groupe 9514",
    transform: "translate(0.001 0.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9511",
    "data-name": "Groupe 9511",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9480",
    "data-name": "Groupe 9480",
    transform: "translate(1057.982 285.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16056",
    "data-name": "Trac\\xE9 16056",
    d: "M296.992,159.52,84.628,102.594l-.17-.2L.013,1.032,1.247.016,85.522,101.168l211.853,56.79Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9481",
    "data-name": "Groupe 9481",
    transform: "translate(752.745 223.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16057",
    "data-name": "Trac\\xE9 16057",
    d: "M161.232,179.459.726,57.557,97.244,1.225l.843,1.4L3.631,57.757,162.192,178.18Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9482",
    "data-name": "Groupe 9482",
    transform: "translate(627.558 72.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16058",
    "data-name": "Trac\\xE9 16058",
    d: "M107.466,118.956l-1.593-.333,21.1-113.94L1.69,72.242l-.8-1.428L129.19,1.628Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9483",
    "data-name": "Groupe 9483",
    transform: "translate(958.293 169.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16059",
    "data-name": "Trac\\xE9 16059",
    d: "M3.281,133.456l-1.6-.286L16.947,34.131,193.1,74.75,419.049,5.28l.512,1.548L193.2,76.425,18.29,36.092Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9484",
    "data-name": "Groupe 9484",
    transform: "translate(1269.004 15.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16060",
    "data-name": "Trac\\xE9 16060",
    d: "M5.542,330.2l-1.388-.868L107.9,159.6,178.364,28.867,134.72,3.1l.8-1.388L180.534,28.29l-.37.686L109.31,160.435Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9485",
    "data-name": "Groupe 9485",
    transform: "translate(959.852 242.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16061",
    "data-name": "Trac\\xE9 16061",
    d: "M1.086,61.677.758,60.084l97.749-17.74L191.253,2.41l.672,1.489-92.911,40-.09.017Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9486",
    "data-name": "Groupe 9486",
    transform: "translate(244.739 183.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16062",
    "data-name": "Trac\\xE9 16062",
    d: "M225.8,220.425,161.67,4.168,1.355,62.4.768,60.875,162.72,2.05l.251.847,63.445,213.936L306.06,108.808l172.321,30.031,31.15-41.609,1.306.99L479.108,140.6,306.8,110.572Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9487",
    "data-name": "Groupe 9487",
    transform: "translate(35.923 46.291)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16063",
    "data-name": "Trac\\xE9 16063",
    d: "M172.057,455.555l-1.126-1.191L311,322.588l.432.114,119.339,31.391-221.3-154.38L1.123,89.063,38.617.487,140.491,65.538,267.138,98.859l-.375,1.564-126.9-33.388-.11-.07L39.381,2.873,3.2,88.351,210.288,198.336l.042.029L439.083,357.944l-127.6-33.564Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9488",
    "data-name": "Groupe 9488",
    transform: "translate(2.102 131.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16064",
    "data-name": "Trac\\xE9 16064",
    d: "M207.595,372.22l-204.742-146L35.583.448,152.815,268.135l192.1-30.8.3,1.6L153.569,269.66ZM4.6,225.5l198.435,141.5L151.1,268.41l.079-.012L36.382,6.272Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9489",
    "data-name": "Groupe 9489",
    transform: "translate(406.447 186.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16065",
    "data-name": "Trac\\xE9 16065",
    d: "M201.865,192.673,144.135,107.8.016,1.3.958.012,145.306,106.678l.08.118,55.762,81.978L238.321,38.091l110.51,56.465-.708,1.437L239.417,40.45Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9490",
    "data-name": "Groupe 9490",
    transform: "translate(956.739 36.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16066",
    "data-name": "Trac\\xE9 16066",
    d: "M378.912,570.828,397.4,408.82l-75.088,59.173-.513-.44L186.471,351.293,121.4,441.226,3.367,266.948l1.335-.884L121.418,438.4l64.747-89.48L322.322,465.9l74.953-59.066L316.62,309.636l-1.8-.789,1.338-.425L268.531,96.1l64.395-25.736L283.716,31.251,497.708,6.272l-161.6,64.584,85.361,67.856.078.125,71,115.287-.964.306L319.4,309.105,495.34,386.368Zm20.543-165.717-18.12,158.809L492.958,387.073l-173.069-76,78.641,94.768Zm-129.047-308,47.3,210.821,172.391-54.741L420.25,139.785,334.4,71.539Zm17.341-64.7,46.887,37.271L485.719,9.306Z",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9491",
    "data-name": "Groupe 9491",
    transform: "translate(750.561 73.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16067",
    "data-name": "Trac\\xE9 16067",
    d: "M307.494,212.887l-82.628-80.375L0,0,208.132,50.626l-.345,1.572L10.155,4.126l215.681,127.1.072.07,82.7,80.446Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9492",
    "data-name": "Groupe 9492",
    transform: "translate(628.85 143.651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16068",
    "data-name": "Trac\\xE9 16068",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "#002b53",
    stroke: "#d1d1d1",
    strokeWidth: 3.031
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9493",
    "data-name": "Groupe 9493",
    transform: "translate(345.869 290.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16234",
    "data-name": "Trac\\xE9 16234",
    d: "M0,0,217.831,2.116l.016,1.632L.016,1.632Z",
    transform: "translate(0.996 78.998) rotate(-21.092)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9494",
    "data-name": "Groupe 9494",
    transform: "translate(38.085 134.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16069",
    "data-name": "Trac\\xE9 16069",
    d: "M0,0",
    fill: "#002b53",
    stroke: "#d1d1d1",
    strokeWidth: 3.031
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9495",
    "data-name": "Groupe 9495",
    transform: "translate(1077.302 418.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16070",
    "data-name": "Trac\\xE9 16070",
    d: "M.96,59.394.729,57.786,277.712,24.942,373.4,4.705l.374,1.584L278.015,26.541l-.036,0Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9496",
    "data-name": "Groupe 9496",
    transform: "translate(1058.392 284.747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16235",
    "data-name": "Trac\\xE9 16235",
    d: "M3.982,0,5.59-.017,3.216,223.476l-1.608.017Z",
    transform: "matrix(0.259, -0.966, 0.966, 0.259, -1.012, 5.409)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9497",
    "data-name": "Groupe 9497",
    transform: "translate(1225.735 132.721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16071",
    "data-name": "Trac\\xE9 16071",
    d: "M220.432,431.076,53.066,371.766l.507-1.524,162.4,57.549L128.454,311.056l.28-.462,92.506-152.665L.017,1.324.931.012,223.412,157.506l-.39.643L130.407,310.994Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9498",
    "data-name": "Groupe 9498",
    transform: "translate(848.05 202.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16072",
    "data-name": "Trac\\xE9 16072",
    d: "M65.084,200.793,111.7,100.868.284,22.514l127.427-20.9.3,1.6L4.438,23.48l109.309,76.871-.288.616-45.728,98.02L294.24,183.451l8.343-140.635,1.617.136L295.775,184.97l-.692.048Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9499",
    "data-name": "Groupe 9499",
    transform: "translate(493.256 160.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16073",
    "data-name": "Trac\\xE9 16073",
    d: "M0,0",
    fill: "#002b53",
    stroke: "#d1d1d1",
    strokeWidth: 3.031
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9500",
    "data-name": "Groupe 9500",
    transform: "translate(244.395 183.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16074",
    "data-name": "Trac\\xE9 16074",
    d: "M103.086,187.636.782,62.022l1.246-1,100.423,123.3L161.992,2.041l98.995,22.923.18.327,45.861,83.089,93.489-67.493.094-.036L489.523,6.363l.619,1.511L401.324,42.325,306.516,110.77l-46.583-84.4L163.086,3.947Z",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9501",
    "data-name": "Groupe 9501",
    transform: "translate(1443.936 562.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16075",
    "data-name": "Trac\\xE9 16075",
    d: "M0,0",
    fill: "#002b53",
    stroke: "#d1d1d1",
    strokeWidth: 3.031
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9502",
    "data-name": "Groupe 9502",
    transform: "translate(503.605 140.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16076",
    "data-name": "Trac\\xE9 16076",
    d: "M639.417,246.919l-.287-.131-182.086-83.51L219.529,183.409l-.278-.349L140.956,84.9,124.671,4.047,1.644,69.345.857,67.912,125.819,1.585,142.465,84.23l77.764,97.492,237.065-20.094.2.09,182,83.47,130.5-41.039.521,1.545Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9503",
    "data-name": "Groupe 9503",
    transform: "translate(0.824 65.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16077",
    "data-name": "Trac\\xE9 16077",
    d: "M65.111,506.315,4.353,292.807l-.662-.193L4.122,292l-.082-.287.416-.194L174.608,46.764l1.338.946L7.412,290.132,244.394,179.345l57.289-99.759.645.254,103.795,40.752,86.892-26.61,11.669,49.4,139.681,15.849,88.985-34.516.268.08,114.151,34.154L754.132,10.357,755.5,9.52l95.908,152.2-117.947-35.29-88.84,34.46-.2-.022-141.042-16-11.53-48.817L406.1,122.3l-.266-.1L302.415,81.6,245.558,180.6l-.224.1L7.3,291.989l147.494,42.85-.461.883ZM6.176,293.337,65.544,501.958,152.43,335.826Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9504",
    "data-name": "Groupe 9504",
    transform: "translate(755.638 75.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16078",
    "data-name": "Trac\\xE9 16078",
    d: "M0,0",
    fill: "#002b53",
    stroke: "#d1d1d1",
    strokeWidth: 3.031
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9505",
    "data-name": "Groupe 9505",
    transform: "translate(492.904 141.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16079",
    "data-name": "Trac\\xE9 16079",
    d: "M261.23,140.46l-20.6-90.087-104.788-47L.47,20.051.233,18.445l135.82-16.73.21.094L242.02,49.241l.093.4,20.7,90.492Z",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9506",
    "data-name": "Groupe 9506",
    transform: "translate(754.923 281.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16080",
    "data-name": "Trac\\xE9 16080",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "#002b53",
    stroke: "#d1d1d1",
    strokeWidth: 3.031
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9507",
    "data-name": "Groupe 9507",
    transform: "translate(733.105 120.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16081",
    "data-name": "Trac\\xE9 16081",
    d: "M418.586,125.91l-.668-.419L318.859,63.4,242.2,85.353,224.813,4.9,1.37,70.937l-.5-1.553L226.017,2.848l.115.533L319.07,61.64l175.948-50.4ZM320.926,62.8l97.159,60.9,73.1-109.676ZM226.6,5.566,243.41,83.313,317,62.233Z",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9508",
    "data-name": "Groupe 9508",
    transform: "translate(1058.612 285.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16082",
    "data-name": "Trac\\xE9 16082",
    d: "M0,0",
    fill: "#002b53",
    stroke: "#d1d1d1",
    strokeWidth: 3.031
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9509",
    "data-name": "Groupe 9509",
    transform: "translate(606.905 321.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16236",
    "data-name": "Trac\\xE9 16236",
    d: "M0,0,127.293,1.072l.013,1.634L.013,1.634Z",
    transform: "translate(0.693 54.917) rotate(-25.31)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9510",
    "data-name": "Groupe 9510",
    transform: "translate(850.411 225.675)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16083",
    "data-name": "Trac\\xE9 16083",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "#002b53",
    stroke: "#d1d1d1",
    strokeWidth: 3.031
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9512",
    "data-name": "Groupe 9512",
    transform: "translate(147.595 111.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16084",
    "data-name": "Trac\\xE9 16084",
    d: "M3.69,292.568l93.59-159.14L27.791,1.091l1.43-.723,69.91,133.14-.225.383L9.992,285.082,258.806,74.318l1.065,1.246Z",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9513",
    "data-name": "Groupe 9513",
    transform: "translate(467.627 208.842)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16237",
    "data-name": "Trac\\xE9 16237",
    d: "M0,3.906l195.809-2.28-.019,1.627L-.019,5.533Z",
    transform: "matrix(0.185, -0.983, 0.983, 0.185, -1.401, 192.588)",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9515",
    "data-name": "Groupe 9515",
    transform: "translate(1223.734 15.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16085",
    "data-name": "Trac\\xE9 16085",
    d: "M153.664,161.458,1.5,118.6,18.061,52.621l.421-.131L180.131,2.27l.516,1.546L19.418,53.906,3.457,117.48,154.068,159.9Z",
    fill: "#002b53"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnexionImageMiddle);
export default __webpack_public_path__ + "static/media/connexion_image_middle.561ebb69f688c061bb15f03ae8715354.svg";
export { ForwardRef as ReactComponent };